export const getAppVersion = () => {
    return 1;
  };